import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29817bc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-account-input" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "select-account-input__info-icon"
}
const _hoisted_4 = { class: "select-account-input__info-name" }
const _hoisted_5 = { class: "select-account-input__title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

import ChevronSmallDown from "@/icons/common/chevron-small-down.vue";
import DropdownWrapper from "@/components/dropdown-wrapper/index.vue";
import AccountSelect from "@/components/account-select/index.vue";
import { Account } from "@/types/account";
import { computed, PropType, ref } from "vue";
import { onClickOutside } from "@vueuse/core";
import { Token } from "@/types/token";
import { nativeBalances, nativeToken } from "@/stores";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  account: {
    type: Object as PropType<Account>,
    default: null,
  },
  accounts: {
    type: Object as PropType<Array<Account>>,
    default: () => ({}),
  },
  title: {
    type: String,
    default: "From",
  },
  amount: {
    type: Number,
    default: 0,
  },
  token: {
    type: Object as PropType<Token>,
    default: nativeToken.value,
  },
  isAmount: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:select"],
  setup(__props, { emit }) {

const props = __props;

const isOpenDropdown = ref<boolean>(false);
const dropdown = ref(null);
const toggle = ref(null);





const toggleAccounts = () => {
  isOpenDropdown.value = !isOpenDropdown.value;
};

const selectAccount = (account: Account) => {
  emit("update:select", account);
  toggleAccounts();
};

const availableBalance = computed(() => {
  if (props.isAmount && props.account) {
    const balance = nativeBalances[props.account.address];

    if (balance) return Number(balance.available);
  }

  return 0;
});

onClickOutside(
  dropdown,
  () => {
    toggleAccounts();
  },
  { ignore: [toggle] }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      ref_key: "toggle",
      ref: toggle,
      class: "select-account-input__info",
      onClick: toggleAccounts
    }, [
      (__props.account?.image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.account.image
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("div", _hoisted_3)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h5", _hoisted_5, _toDisplayString(__props.title), 1),
        (__props.account)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
              _createTextVNode(_toDisplayString(__props.account?.name) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$filters.replaceWithEllipsis(__props.account?.address, 6, 6)), 1),
              (__props.isAmount)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.$filters.cryptoCurrencyFormat(__props.amount || availableBalance.value)) + " ", 1),
                    _createElementVNode("span", null, _toDisplayString(__props.token.symbol), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_8, "Select an account to send from"))
      ]),
      _createVNode(ChevronSmallDown)
    ], 512),
    (isOpenDropdown.value)
      ? (_openBlock(), _createBlock(DropdownWrapper, {
          key: 0,
          ref_key: "dropdown",
          ref: dropdown
        }, {
          default: _withCtx(() => [
            _createVNode(AccountSelect, {
              accounts: __props.accounts,
              "onUpdate:selectAccount": selectAccount
            }, null, 8, ["accounts"])
          ]),
          _: 1
        }, 512))
      : _createCommentVNode("", true)
  ]))
}
}

})